import React, { FC } from 'react';
import styled from 'styled-components';
import { ArrowDropDown } from '@clds/icon';
import { ItemLayout } from '@clds/item';
import { Button, ButtonSize, ButtonTone } from '@clds/button';
import { unselect } from '@clds/compound-components';
import { MenuItem } from '@clds/menu';
import { DropdownMenu } from '@cld/dropdown-menu';
import { Version, VersionName } from '..';
import { OverflowedVersion } from './OverflowedVersion';

export interface SnippetsVersionsProps {
  onVersionChange?: (version: VersionName) => void;
  langVersion?: string;
  versions: Version[];
  size?: ButtonSize;
  tone?: ButtonTone;
}

export const SnippetVersionsMenu = styled<FC<SnippetsVersionsProps>>(({ langVersion, versions, onVersionChange, size = 'sm', tone }) => {
  return (
    <DropdownMenu
      selectedId={langVersion ?? unselect}
      onSelect={(id) => id !== unselect && onVersionChange?.(id)}
      items={versions.map((version: Version) => (
        <MenuItem key={version?.versionName} id={version?.versionName} isSelected={version?.versionName === langVersion}>
          <ItemLayout>{version?.versionName}</ItemLayout>
        </MenuItem>
      ))}
    >
      {langVersion && (
        <Button size={size} variant="secondary" rightSlot={<ArrowDropDown />} data-test-specifier="version-menu" tone={tone}>
          <OverflowedVersion version={langVersion} />
        </Button>
      )}
    </DropdownMenu>
  );
})``;
